import { route } from 'ziggy-js'
import { router } from "@inertiajs/vue3";
import { useRouter } from "@/helpers/composables/useRouter";
import { useFetch } from "@/helpers/composables/useFetch";
import { useSettingsStore } from "@/store/settings";
import NProgress from "nprogress";
import { ref } from "vue";
export function usePaymentMethod() {
    let errors = ref({});
    const {setNotificationMessage} = useSettingsStore();
    const { to } = useRouter({
        router, route
    });

    const isLoading = ref(false);
    const createConsumerCreditCard = (credit_card, { afterFetch }) => {
        const { data } = useFetch(route("endpoint.consumer_credit_cards.store"), {
            beforeFetch: (ctx) => {
                let { cancel } = ctx;
                if(isLoading.value){
                    cancel()
                }
                NProgress.start();
                isLoading.value = true;
                ctx.options.headers = {
                    ...ctx.options.headers,
                    Accept: 'application/json',
                }
                return ctx;
            },
            afterFetch: async (ctx) => {
                if (afterFetch && typeof afterFetch === "function") {
                    await afterFetch(ctx);
                }
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                setNotificationMessage({
                    type: "success",
                    message: "Card added successfully"
                });
                isLoading.value = false;
            },
            onFetchError: async (ctx) => {
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                if(ctx?.data?.error){
                    setNotificationMessage({
                        message: ctx.data.error,
                        type: 'error'
                    })
                }
                isLoading.value = false;
            }
        }).post({
            credit_card
        }).json();
        return data;
    };

    const createCompanyCreditCard = (credit_card, { afterFetch }) => {
        const { data } = useFetch(route("endpoints.creditcards.store"), {
            beforeFetch: (ctx) => {
                if(isLoading.value){
                    ctx.cancel()
                }
                NProgress.start();
                ctx.options.headers = {
                    ...ctx.options.headers,
                    Accept: 'application/json',
                }
                isLoading.value = true;
                return ctx
            },
            afterFetch: async (ctx) => {
                if (afterFetch && typeof afterFetch === "function") {
                    await afterFetch(ctx);
                }
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                setNotificationMessage({
                    type: "success",
                    message: "Card added successfully"
                });
                isLoading.value = false;
            },
            onFetchError: async (ctx) => {
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                if(ctx?.data?.error){
                    setNotificationMessage({
                        message: ctx.data.error,
                        type: 'error'
                    })
                }

                if(ctx?.data?.errors){
                    errors.value = ctx.data.errors;
                }
                isLoading.value = false;
            }
        })
            .post({
                credit_card
            })
            .json();
        return data;
    };

    const updateConsumerCreditCard = (credit_card, { afterFetch }) => {
        credit_card = JSON.parse(JSON.stringify(credit_card));
        const { data } = useFetch(route("endpoint.consumer_credit_cards.update", [credit_card.consumer_credit_card_id]), {
            beforeFetch: (ctx) => {
                if(isLoading.value){
                    ctx.cancel()
                }
                NProgress.start();
                ctx.options.headers = {
                    ...ctx.options.headers,
                    Accept: 'application/json',
                }
                isLoading.value = true;
                return ctx;
            },
            afterFetch: async (ctx) => {
                if (afterFetch && typeof afterFetch === "function") {
                    await afterFetch(ctx);
                }
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                setNotificationMessage({
                    type: "success",
                    message: "Card updated successfully"
                });
                isLoading.value = false;
            },
            onFetchError: async (ctx) => {
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                if(ctx?.data?.error){
                    setNotificationMessage({
                        message: ctx.data.error,
                        type: 'error'
                    })
                }

                if(ctx?.data?.errors){
                    errors.value = ctx.data.errors;
                }
                isLoading.value = false;
            }
        })
            .put({
                credit_card
            })
            .json();
        return data;
    };

    const updateCompanyCreditCard = (credit_card, { afterFetch }) => {
        credit_card = JSON.parse(JSON.stringify(credit_card));
        const { data } = useFetch(route("endpoints.creditcards.update", [credit_card.credit_card_id]), {
            beforeFetch: (ctx) => {
                if(isLoading.value){
                    ctx.cancel()
                }
                NProgress.start();
                ctx.options.headers = {
                    ...ctx.options.headers,
                    Accept: 'application/json',
                }
                isLoading.value = true;
                return ctx;
            },
            afterFetch: async (ctx) => {
                if (afterFetch && typeof afterFetch === "function") {
                    await afterFetch(ctx);
                }
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                setNotificationMessage({
                    type: "success",
                    message: "Card updated successfully"
                });
                isLoading.value = false;
            },
            onFetchError: async (ctx) => {
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                if(ctx?.data?.error){
                    setNotificationMessage({
                        message: ctx.data.error,
                        type: 'error'
                    })
                }

                if(ctx?.data?.errors){
                    errors.value = ctx.data.errors;
                }
                isLoading.value = false;
            }
        })
            .put({
                credit_card
            })
            .json();
        return data;
    };

    const deleteConsumerCreditCard = (consumer_credit_card_id, { afterFetch }) => {
        const { data } = useFetch(route("endpoint.consumer_credit_cards.destroy", consumer_credit_card_id), {
            beforeFetch: (ctx) => {
                if(isLoading.value){
                    ctx.cancel()
                }
                NProgress.start();
                ctx.options.headers = {
                    ...ctx.options.headers,
                    Accept: 'application/json',
                }
                isLoading.value = true;
                return ctx;
            },
            afterFetch: async (ctx) => {
                if (afterFetch && typeof afterFetch === "function") {
                    await afterFetch(ctx);
                }
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                setNotificationMessage({
                    type: "success",
                    message: "Card deleted successfully"
                });
                isLoading.value = false;
            },
            onFetchError: async (ctx) => {
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                if(ctx?.data?.error){
                    setNotificationMessage({
                        message: ctx.data.error,
                        type: 'error'
                    })
                }

                if(ctx?.data?.errors){
                    errors.value = ctx.data.errors;
                }
                isLoading.value = false;
            }
        }).delete().json();
        return data;
    };

    const deleteCompanyCreditCard = (credit_card_id, { afterFetch }) => {
        const { data } = useFetch(route("endpoints.creditcards.destroy", credit_card_id), {
            beforeFetch: (ctx) => {
                if(isLoading.value){
                    ctx.cancel()
                }
                NProgress.start();
                ctx.options.headers = {
                    ...ctx.options.headers,
                    Accept: 'application/json',
                }
                isLoading.value = true;
                return ctx;
            },
            afterFetch: async (ctx) => {
                if (afterFetch && typeof afterFetch === "function") {
                    await afterFetch(ctx);
                }
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                setNotificationMessage({
                    type: "success",
                    message: "Card deleted successfully"
                });
                isLoading.value = false;
            },
            onFetchError: async (ctx) => {
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                if(ctx?.data?.error){
                    setNotificationMessage({
                        message: ctx.data.error,
                        type: 'error'
                    })
                }

                if(ctx?.data?.errors){
                    errors.value = ctx.data.errors;
                }
                isLoading.value = false;
            }
        }).delete().json();
        return data;
    };

    return {
        createConsumerCreditCard,
        createCompanyCreditCard,
        updateConsumerCreditCard,
        updateCompanyCreditCard,
        deleteConsumerCreditCard,
        deleteCompanyCreditCard,
        errors
    }
}